var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H15M12 1.5V3M6 1.5V3M5.40015 3H12.6001C13.4402 3 13.86 3 14.1808 3.16349C14.4631 3.3073 14.6929 3.53679 14.8367 3.81903C15.0002 4.1399 15 4.55988 15 5.39996V12.6C15 13.44 15.0002 13.8602 14.8367 14.181C14.6929 14.4633 14.4631 14.6927 14.1808 14.8365C13.86 15 13.4402 15 12.6001 15H5.40015C4.56007 15 4.13972 15 3.81885 14.8365C3.5366 14.6927 3.3073 14.4633 3.16349 14.181C3 13.8602 3 13.44 3 12.6V5.39996C3 4.55988 3 4.1399 3.16349 3.81903C3.3073 3.53679 3.5366 3.3073 3.81885 3.16349C4.13972 3 4.56007 3 5.40015 3Z",
    stroke: "#7C4095",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.3bba34e1d26cb1a88220284bc11ba3ff.svg";
export { ForwardRef as ReactComponent };